import React from "react";
import { Button, dialog } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import ScheduleTemplatePresenter from "./ScheduleTemplatePresenter";
import CardView from "../../../components/common/CardView";
import { DialogConfirmation } from "../../../components/common/Converter";
import Progress from "../../../components/Progress";
import Queue from "nq";

class ScheduleTemplatePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ScheduleTemplatePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = { objects: [], count: 0, limit: 50, current: 1 };
  }

  getCollectionName() {
    return "schedule_template";
  }

  createSchedule() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  handleViewData(data) {
    this.navigateTo(`/view/${this.getCollectionName()}/${data.id}`);
  }

  // delete function
  async handleDeleteData(data) {
    try {
      // delete collection data
      DialogConfirmation(data.id, this.getCollectionName(), () => {
        // this.deleteCronJobsPermanently(data);
        this.refetchData();
      });
    } catch (e) {
      console.error("delete scheudle Error: ", e.message || e);
    }
  }

  // async deleteCronJobsPermanently(data) {
  //   // delete cronjobs
  //   try {
  //     const cronJob = await findObjectUseCase().execute("_cronjobs", {
  //       where: { scheduleID: data.id },
  //     });
  //     if (cronJob.length > 0) {
  //       for (const cron of cronJob) {
  //         try {
  //           await new Queue.Document().delete("_cronjobs", cron.id);
  //         } catch (e) {
  //           console.error("delete cron: ", e.message || e);
  //         }
  //       }
  //     }
  //   } catch (e) {
  //     console.error("find cron: ", e.message || e);
  //   }
  // }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Reference Table {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        onClick={this.createSchedule.bind(this)}
                        // onClick={this.onClickAdd.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                progress={loading}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "region",
                    "office",
                    "division",
                    "section",
                    "unit",
                    "cluster",
                  ],
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(ScheduleTemplatePage);
